import React, { Component } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import Slider from 'react-slick'
import Fade from 'react-reveal/Fade'

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{this.props.children}</>)
  }
}

const BrandsShowcase = ({ brands = [], disableLinking = false }) => {

  const settings = {
    speed: 600,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 5000,
    slidesToShow: 8,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    cssEase: 'ease',
    swipe: false,
    focusOnSelect: false,
    adaptiveHeight: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
    ]
  }

  return (
    <section className='brands-showcase'>
      <div className='brands-showcase__inner'>
        {brands?.length > 0 &&
          <BlockUpdate>
            <Slider {...settings}>
              {brands?.map((el, i) => {
                if (!disableLinking) {
                  return (
                    <Fade bottom distance={'40px'} key={i}>
                      <Link className='brands-showcase__item' key={i} to={el.uri}>
                        {el.brandInfo?.logo?.grayscale && <GatsbyImage image={getImage(el.brandInfo.logo.localFile)} alt={el.title} />}
                        <span>{el.title}</span>
                      </Link>
                    </Fade>
                  )
                }
                return (
                  <Fade bottom distance={'40px'} key={i}>
                    <div className='brands-showcase__item' key={i} to={el.uri}>
                      {el.brandInfo?.logo?.grayscale && <GatsbyImage image={getImage(el.brandInfo.logo.localFile)} alt={el.title} />}
                      <span>{el.title}</span>
                    </div>
                  </Fade>
                )
              })}
            </Slider>
          </BlockUpdate>
        }
      </div>
    </section>
  )
}

export default BrandsShowcase